namespace $ {
	
	/// Global storage of temporary state
	export var $mol_state_stack = new $mol_dict< string , any >()
	
}
